import BorderClearIcon from "@mui/icons-material/BorderClear";
import BorderInnerIcon from "@mui/icons-material/BorderInner";
import BorderAllIcon from "@mui/icons-material/BorderAll";
import BorderOuterIcon from "@mui/icons-material/BorderOuter";

export const buildCategories = [
  {
    id: 1,
    value: "All",
    label: "All",
    icon: BorderAllIcon,
  },
  {
    id: 2,
    value: "AMD",
    label: "AMD Builds",
    img: "/assets/images/icons/amd_sticker.jpg",
  },
  {
    id: 3,
    value: "Intel",
    label: "Intel Builds",
    img: "/assets/images/icons/intel_sticker.jpg",
  },
  {
    id: 4,
    value: "Entry",
    label: "Entry-level",
    icon: BorderClearIcon,
  },
  {
    id: 5,
    value: "Mid",
    label: "Mid-level",
    icon: BorderInnerIcon,
  },
  {
    id: 6,
    value: "Premium",
    label: "Premium-level",
    icon: BorderOuterIcon,
  },
];

export const cpuTypes = [
  {
    id: 2,
    value: "AMD",
    label: "AMD Builds",
    img: "/assets/images/icons/amd_sticker.jpg",
  },
  {
    id: 3,
    value: "Intel",
    label: "Intel Builds",
    img: "/assets/images/icons/intel_sticker.jpg",
  },
];

export const buildTier = [
  {
    id: 4,
    value: "Entry",
    label: "Entry-level",
    icon: BorderClearIcon,
  },
  {
    id: 5,
    value: "Mid",
    label: "Mid-level",
    icon: BorderInnerIcon,
  },
  {
    id: 6,
    value: "Premium",
    label: "Premium-level",
    icon: BorderOuterIcon,
  },
];
